var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcLinkButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\uB808\\uC774\\uC5B4_2",
    "data-name": "\\uB808\\uC774\\uC5B4 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21 21.53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill-rule: evenodd;\n        stroke: #000;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\uB808\\uC774\\uC5B4_1-2",
    "data-name": "\\uB808\\uC774\\uC5B4 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m5.87,7.28c.41,0,.75.34.75.75s-.34.75-.75.75h-.93c-1.62,0-2.93,1.31-2.93,2.93v4.88c0,1.62,1.31,2.93,2.93,2.93h11.13c1.62,0,2.93-1.31,2.93-2.93v-4.88c0-1.61-1.31-2.92-2.92-2.93h-.94c-.41,0-.75-.34-.75-.75s.34-.75.75-.75h.94c2.44,0,4.42,1.98,4.42,4.43v4.88c0,2.45-1.99,4.43-4.43,4.43H4.93c-2.45,0-4.43-1.99-4.43-4.44v-4.88c0-2.45,1.99-4.43,4.43-4.43,0,0,.93,0,.93,0ZM11.03.71l2.92,2.93c.28.3.26.78-.04,1.06-.29.27-.74.27-1.02,0l-1.64-1.64v10.98s-1.5,0-1.5,0V3.06l-1.64,1.64c-.29.29-.76.3-1.06,0,0,0,0,0,0,0-.29-.29-.29-.77,0-1.06,0,0,0,0,0,0l2.92-2.93c.3-.28.76-.28,1.06,0h0Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLinkButton);
export default __webpack_public_path__ + "static/media/ic_link_button.e892e2a230566bba3760e220d150ffc1.svg";
export { ForwardRef as ReactComponent };